module.exports = "<div class=\"map-visualization-container\">\n    <div resize-event=\"handleResize()\" style=\"width:100%; height:100%;\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/visualizations/map/map.html
// module id = 724
// module chunks = 1